import { promotionListsByPageQueryKey } from '@/entities/Promotions'
import { topliApi } from '@/shared/api/topli/TopliApi'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const deletePromotion = async (promotionId: number) => {
  const response = await topliApi.promotions.delete(promotionId)
  return response
}

export const useDeletePromotionApi = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: number) => deletePromotion(id),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: [promotionListsByPageQueryKey],
        refetchType: 'active',
      })
    },
  })
}
